import React, { Component } from 'react'
import Dialog from '../../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { messageActions } from '../../../actions'
import * as API from '../../../api'
import { formatContentSelectValue, getApiErrorMessage } from '../../../utils'
import { getBookCmsPlan, saveBookCmsPlan } from '../../../utils/bookVectorizationCmsPlan'
import BookVectorizationFlow from '../../../components/BookVectorizationFlow'
import { processingModalStyles } from './styles'
import ChapterFormModal from './ChapterFormModal'
import ChapterList from './ChapterList'
import { STATUS_LABELS } from '../../../constants/vectorization'

class ProcessingModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: null,
      statusData: null,
      filesData: null,
      filesError: null,
      chaptersData: null,
      chaptersError: null,
      reprocessing: false,
      chapterStatuses: {},
      chapterStatusLoading: false,
      chapterStatusError: null,
      selectedChapter: null,
      selectedChapterIndex: null,
      cmsTituloLivro: '',
      cmsIsbnLivro: '',
      cmsAutoresLivro: [],
      cmsEspecialidadesLivro: [],
      cmsEdicaoLivro: '',
      cmsCodigoProtheus: '',
      cmsCopyrightLivro: '',
      cmsPlan: null,
      cmsMetadataLoading: false,
      cmsMetadataError: null,
      chapterDefaults: {},
    }
  }

  componentDidMount() {
    this.fetchProcessingData()
  }

  applyCmsPreRegistration = (preRegistration, previousPlan) => {
    const { isbn, bookName } = this.props
    const cms = {
      autoresLivro: formatContentSelectValue(preRegistration.autores || []),
      especialidadesLivro: formatContentSelectValue(preRegistration.especialidades || []),
      edicaoLivro: preRegistration.edicao || '',
      codigoProtheus: preRegistration.codigo || '',
      copyrightLivro: preRegistration.copyright || '',
    }
    const plan = {
      ...(previousPlan || {}),
      enabled: true,
      cmsStatus: 'pre-registered',
      preRegistrationId: preRegistration._id,
      title: preRegistration.titulo || bookName || '',
      isbn: preRegistration.isbn || isbn,
      cms,
      source: 'cms-pre-registration',
    }

    saveBookCmsPlan(isbn, plan)
    this.setState({
      cmsTituloLivro: plan.title,
      cmsIsbnLivro: plan.isbn,
      cmsAutoresLivro: cms.autoresLivro,
      cmsEspecialidadesLivro: cms.especialidadesLivro,
      cmsEdicaoLivro: cms.edicaoLivro,
      cmsCodigoProtheus: cms.codigoProtheus,
      cmsCopyrightLivro: cms.copyrightLivro,
      cmsPlan: plan,
      cmsMetadataLoading: false,
      cmsMetadataError: null,
    })
  }

  loadCmsPlan = () => {
    const { isbn, bookName } = this.props
    const plan = getBookCmsPlan(isbn)

    this.setState({
      cmsTituloLivro: (plan || {}).title || bookName || '',
      cmsIsbnLivro: (plan || {}).isbn || isbn,
      cmsPlan: plan || null,
      cmsAutoresLivro: (((plan || {}).cms || {}).autoresLivro || []),
      cmsEspecialidadesLivro: (((plan || {}).cms || {}).especialidadesLivro || []),
      cmsEdicaoLivro: (((plan || {}).cms || {}).edicaoLivro || ''),
      cmsCodigoProtheus: (((plan || {}).cms || {}).codigoProtheus || ''),
      cmsCopyrightLivro: (((plan || {}).cms || {}).copyrightLivro || ''),
      cmsMetadataLoading: true,
      cmsMetadataError: null,
    })

    const request = plan && plan.preRegistrationId
      ? API.preRegistrations.getPreRegistration(plan.preRegistrationId)
      : API.preRegistrations.getBookPreRegistrationByIsbn(isbn)

    return request
      .catch((err) => {
        const notFound = err && err.response && err.response.status === 404
        if (notFound && plan && plan.preRegistrationId) {
          return API.preRegistrations.getBookPreRegistrationByIsbn(isbn)
        }
        return Promise.reject(err)
      })
      .then((response) => this.applyCmsPreRegistration(response.data || {}, plan))
      .catch((err) => {
        const notFound = err && err.response && err.response.status === 404
        this.setState({
          cmsMetadataLoading: false,
          cmsMetadataError: notFound
            ? 'Pré-cadastro não encontrado no CMS. Abra o livro para cadastrar os metadados.'
            : getApiErrorMessage(err, 'Não foi possível atualizar os metadados do CMS.'),
        })
      })
  }

  fetchProcessingData = () => {
    const { isbn, changeMessage } = this.props

    this.setState({
      loading: true,
      error: null,
      filesError: null,
      chaptersError: null,
    })

    this.loadCmsPlan()

    const statusPromise = API.bookVectorization.getBookStatus(isbn)
    const filesPromise = API.bookVectorization.getBookFiles(isbn)
    const chaptersPromise = API.bookVectorization.getBookChapters(isbn)

    Promise.all([
      statusPromise,
      filesPromise.catch((err) => {
        return { filesError: this.getErrorMessage(err), data: null }
      }),
      chaptersPromise.catch((err) => {
        return { chaptersError: this.getErrorMessage(err), data: null }
      }),
    ])
      .then(([statusResponse, filesResponse, chaptersResponse]) => {
        const chaptersData = chaptersResponse.chaptersError ? null : chaptersResponse.data || {}

        this.setState({
          loading: false,
          statusData: statusResponse.data || {},
          filesData: filesResponse.filesError ? null : filesResponse.data || {},
          filesError: filesResponse.filesError || null,
          chaptersData,
          chaptersError: chaptersResponse.chaptersError || null,
        }, () => {
          if (chaptersData) this.fetchChapterStatuses(this.getChapters())
        })
      })
      .catch((err) => {
        const errorMsg = this.getErrorMessage(err) || 'Erro ao buscar status do livro.'
        this.setState({ loading: false, error: errorMsg, statusData: null })
        changeMessage({ message: errorMsg })
      })
  }

  getErrorMessage = (err) => {
    return getApiErrorMessage(err, 'Erro ao consultar processamento.')
  }

  handleReprocess = () => {
    const { isbn, changeMessage } = this.props

    this.setState({ reprocessing: true, error: null })

    API.bookVectorization
      .reprocessBook(isbn)
      .then((response) => {
        this.setState({
          reprocessing: false,
          statusData: response.data || this.state.statusData,
        })
        changeMessage({ message: 'Livro enviado para reprocessamento.' })
        this.fetchProcessingData()
      })
      .catch((err) => {
        const errorMsg = this.getErrorMessage(err) || 'Erro ao reprocessar livro.'
        this.setState({ reprocessing: false, error: errorMsg })
        changeMessage({ message: errorMsg })
      })
  }

  formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return '--'
    if (seconds < 60) return Math.round(seconds) + 's'
    const min = Math.floor(seconds / 60)
    const sec = Math.round(seconds % 60)
    return min + 'min ' + sec + 's'
  }

  formatDate = (dateStr) => {
    if (!dateStr) return '--'
    try {
      const d = new Date(dateStr)
      return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' })
    } catch (e) {
      return dateStr
    }
  }

  isErrorStatus = (status) => {
    return (status || '').startsWith('ERRO')
  }

  isFinalizedStatus = (status) => {
    return status === 'FINALIZADO' || status === 'vetorizado'
  }

  getChapters = () => {
    const data = this.state.chaptersData || {}

    return data.capitulos || data.items || data.chapters || []
  }

  getChapterIdVetor = (chapter) => {
    return (chapter || {}).idVetor || (chapter || {}).id_vetor || (chapter || {}).id || ''
  }

  getCmsBookData = () => ({
    autoresLivro: this.state.cmsAutoresLivro,
    especialidadesLivro: this.state.cmsEspecialidadesLivro,
    edicaoLivro: this.state.cmsEdicaoLivro,
    codigoProtheus: this.state.cmsCodigoProtheus,
    copyrightLivro: this.state.cmsCopyrightLivro,
    livroReferencia: (this.state.cmsPlan || {}).preRegistrationId
      ? {
          value: this.state.cmsPlan.preRegistrationId,
          label: this.state.cmsTituloLivro || this.props.bookName || this.props.isbn,
        }
      : '',
  })

  fetchChapterStatuses = (chapters) => {
    const { isbn } = this.props
    const idVetores = (chapters || [])
      .map(this.getChapterIdVetor)
      .filter((idVetor, index, values) => idVetor && values.indexOf(idVetor) === index)

    this.setState({ chapterStatusLoading: true, chapterStatusError: null })

    return API.content
      .getVectorizationChapterStatus(isbn, idVetores)
      .then((response) => {
        const items = (response.data || {}).items || []
        const chapterStatuses = {}

        items.forEach((status) => {
          const content = status.content || (status.exists === undefined ? status : null)
          const idVetor = this.getChapterIdVetor(content || status)

          if (content && !chapterStatuses[idVetor]) {
            chapterStatuses[idVetor] = content
          }
        })

        this.setState({
          chapterStatuses,
          chapterStatusLoading: false,
          chapterStatusError: null,
        })

        return chapterStatuses
      })
      .catch((err) => {
        const chapterStatusError = getApiErrorMessage(
          err,
          'Não foi possível consultar os capítulos já cadastrados no CMS.',
        )

        this.setState({ chapterStatusLoading: false, chapterStatusError })
        return {}
      })
  }

  getChaptersWithCmsStatus = () => {
    const { chapterStatuses } = this.state

    return this.getChapters().map((chapter) => ({
      ...chapter,
      cmsContent: chapterStatuses[this.getChapterIdVetor(chapter)] || null,
    }))
  }

  handleReviewChapter = (chapter, index) => {
    const { isbn } = this.props

    saveBookCmsPlan(isbn, {
      enabled: true,
      cmsStatus: 'review-required',
      title: this.state.cmsTituloLivro || '',
      isbn: this.state.cmsIsbnLivro || isbn,
      cms: this.getCmsBookData(),
      source: 'book-vectorization-processing-modal',
    })

    this.setState({ selectedChapter: chapter, selectedChapterIndex: index })
  }

  handleChapterSaved = (result) => {
    const { selectedChapterIndex } = this.state
    const chapters = this.getChaptersWithCmsStatus()
    const nextIndex = selectedChapterIndex + 1

    return this.fetchChapterStatuses(chapters).then(() => {
      const repeatedFields = (result || {}).repeatedFields || null
      const repeatedState = repeatedFields ? { chapterDefaults: repeatedFields } : {}

      if (nextIndex < chapters.length) {
        this.setState({
          ...repeatedState,
          selectedChapter: chapters[nextIndex],
          selectedChapterIndex: nextIndex,
        })
      } else {
        this.setState({
          ...repeatedState,
          selectedChapter: null,
          selectedChapterIndex: null,
        })
      }
    })
  }

  handleChapterConflict = (existingContent) => {
    const idVetor = this.getChapterIdVetor(existingContent)

    if (!idVetor) return

    this.setState((state) => ({
      chapterStatuses: {
        ...state.chapterStatuses,
        [idVetor]: existingContent,
      },
    }))
  }

  renderProgressBar = () => {
    const { statusData } = this.state
    if (!statusData) return null

    const progress = statusData.progresso_percent || 0
    const status = statusData.status || ''
    const hasError = statusData.erro || this.isErrorStatus(status)
    const label = STATUS_LABELS[status] || status || 'Desconhecido'

    return (
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <Chip
            label={label}
            size="small"
            color={hasError ? 'secondary' : status === 'FINALIZADO' ? 'default' : 'primary'}
            style={status === 'FINALIZADO' ? { backgroundColor: '#4caf50', color: '#fff' } : undefined}
          />
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {progress}%
          </Typography>
        </div>
        <LinearProgress
          variant="determinate"
          value={progress}
          color={hasError ? 'secondary' : 'primary'}
          style={{ height: 8, borderRadius: 4 }}
        />
        {statusData.duracao_total_segundos != null && (
          <Typography variant="caption" color="textSecondary" style={{ marginTop: 4, display: 'block' }}>
            Tempo total: {this.formatDuration(statusData.duracao_total_segundos)}
          </Typography>
        )}
      </div>
    )
  }

  renderErrorDetails = () => {
    const { statusData } = this.state
    if (!statusData) return null

    const hasError = statusData.erro || this.isErrorStatus(statusData.status || '')
    if (!hasError) return null

    return (
      <div
        style={{
          background: '#fff3f0',
          border: '1px solid #ffccc7',
          borderRadius: 4,
          padding: 16,
          marginBottom: 24,
        }}
      >
        <Typography variant="subtitle1" style={{ color: '#f44336', fontWeight: 500, marginBottom: 8 }}>
          Detalhes do erro
        </Typography>
        <Typography variant="body2" style={{ color: '#d32f2f', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {statusData.erro_detalhes || 'Nenhum detalhe disponível.'}
        </Typography>
      </div>
    )
  }

  renderTimeline = () => {
    const { statusData } = this.state
    if (!statusData) return null

    const etapas = statusData.etapas || []
    if (!etapas.length) return null

    return (
      <div style={{ marginBottom: 24 }}>
        <Typography variant="subtitle1" style={{ fontWeight: 500, marginBottom: 12 }}>
          Timeline do processamento
        </Typography>
        <div style={{ position: 'relative', paddingLeft: 24 }}>
          {/* Linha vertical da timeline */}
          <div
            style={{
              position: 'absolute',
              left: 7,
              top: 4,
              bottom: 4,
              width: 2,
              backgroundColor: '#e0e0e0',
            }}
          />
          {etapas.map((etapa, idx) => {
            const isError = this.isErrorStatus(etapa.status || '')
            const etapaCompleted = !!etapa.finalizado_em
            const dotColor = isError ? '#f44336' : etapaCompleted ? '#4caf50' : '#1976d2'

            return (
              <div key={idx} style={{ position: 'relative', paddingBottom: 16 }}>
                {/* Ponto da timeline */}
                <div
                  style={{
                    position: 'absolute',
                    left: -20,
                    top: 3,
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: dotColor,
                    border: '2px solid #fff',
                    boxShadow: '0 0 0 2px ' + dotColor,
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      {STATUS_LABELS[etapa.status] || etapa.status || 'Etapa ' + (idx + 1)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {this.formatDate(etapa.iniciado_em)}
                      {etapa.finalizado_em ? ' — ' + this.formatDate(etapa.finalizado_em) : ''}
                    </Typography>
                  </div>
                  {etapa.duracao_segundos != null && (
                    <Chip
                      label={this.formatDuration(etapa.duracao_segundos)}
                      size="small"
                      variant="outlined"
                      style={{ marginLeft: 8, fontSize: '0.7rem' }}
                    />
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderFiles = () => {
    const { filesData, filesError } = this.state
    const { classes } = this.props
    const arquivos = (filesData && filesData.arquivos) || []

    return (
      <div>
        <Typography variant="subtitle1" style={{ fontWeight: 500, marginBottom: 12 }}>
          Arquivos gerados
        </Typography>

        {filesError ? (
          <Typography color="textSecondary">{filesError}</Typography>
        ) : arquivos.length ? (
          <div>
            {arquivos.map((arquivo) => (
              <div key={arquivo.id || arquivo.s3_chave} className={classes.chapterItem}>
                <div className={classes.chapterInfo}>
                  <Typography className={classes.chapterTitle}>
                    {arquivo.etapa || 'Arquivo'}
                  </Typography>
                  <Typography className={classes.chapterMeta}>
                    {arquivo.content_type || '--'} ·{' '}
                    {arquivo.tamanho_bytes
                      ? (arquivo.tamanho_bytes / (1024 * 1024)).toFixed(2) + ' MB'
                      : '--'}
                  </Typography>
                </div>
                {arquivo.url_assinada ? (
                  <Button
                    size="small"
                    color="primary"
                    component="a"
                    href={arquivo.url_assinada}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Abrir
                  </Button>
                ) : null}
              </div>
            ))}
          </div>
        ) : (
          <Typography color="textSecondary">Nenhum arquivo retornado para este ISBN.</Typography>
        )}
      </div>
    )
  }

  renderCmsMetadataFields = () => {
    const { classes } = this.props
    const {
      statusData,
      chaptersError,
      cmsPlan,
      cmsMetadataLoading,
      cmsMetadataError,
      cmsTituloLivro,
      cmsIsbnLivro,
    } = this.state
    const status = (statusData || {}).status || ''
    const finalized = this.isFinalizedStatus(status)
    const chapters = this.getChapters()

    return (
      <fieldset className={classes.fieldset}>
        <legend className={classes.legend}>Pré-cadastro e revisão no CMS</legend>

        <Typography variant="body2" style={{ marginBottom: 8 }}>
          Os metadados do livro já foram informados no pré-cadastro e serão reaproveitados em cada
          capítulo. Revise somente os dados específicos do capítulo antes de cadastrá-lo no CMS.
        </Typography>

        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          Pré-cadastro: {cmsMetadataLoading
            ? 'carregando do CMS'
            : (cmsPlan || {}).preRegistrationId
              ? 'carregado do CMS'
              : 'não identificado'}
        </Typography>

        {cmsTituloLivro ? (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
            Livro no CMS: {cmsTituloLivro}
          </Typography>
        ) : null}

        {cmsIsbnLivro ? (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
            ISBN usado nos capítulos: {cmsIsbnLivro}
          </Typography>
        ) : null}

        {cmsMetadataError ? (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {cmsMetadataError}
          </Typography>
        ) : null}

        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          Status atual: {STATUS_LABELS[status] || status || 'Status não informado'}
        </Typography>

        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          Capítulos encontrados: {chaptersError ? chaptersError : chapters.length}
        </Typography>

        {!finalized ? (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 8 }}>
            O cadastro no CMS fica bloqueado até o processamento chegar em FINALIZADO.
          </Typography>
        ) : null}
      </fieldset>
    )
  }

  renderChapterReview = () => {
    const { classes } = this.props
    const {
      chapterStatusLoading,
      chapterStatusError,
      chaptersError,
      statusData,
    } = this.state
    const status = (statusData || {}).status || ''
    const finalized = this.isFinalizedStatus(status)
    const chapters = this.getChaptersWithCmsStatus()

    return (
      <fieldset className={classes.fieldset}>
        <legend className={classes.legend}>Revisão dos capítulos</legend>

        {!finalized ? (
          <Typography variant="body2" color="textSecondary">
            A revisão ficará disponível quando o processamento chegar em FINALIZADO.
          </Typography>
        ) : chaptersError ? (
          <Typography variant="body2" color="error">
            {chaptersError}
          </Typography>
        ) : chapterStatusLoading ? (
          <div className={classes.statusLoading}>
            <CircularProgress size={24} />
            <Typography variant="body2">Consultando o CMS...</Typography>
          </div>
        ) : chapterStatusError ? (
          <div className={classes.errorBox}>
            <Typography variant="body2" color="error">
              {chapterStatusError}
            </Typography>
            <Button
              color="primary"
              onClick={() => this.fetchChapterStatuses(this.getChapters())}
            >
              Tentar novamente
            </Button>
          </div>
        ) : (
          <ChapterList chapters={chapters} onRegisterChapter={this.handleReviewChapter} />
        )}
      </fieldset>
    )
  }

  renderStatusSummary = () => {
    const { statusData } = this.state
    if (!statusData) return null

    return (
      <div>
        {this.renderProgressBar()}
        {this.renderErrorDetails()}
        {this.renderTimeline()}
        {this.renderFiles()}
      </div>
    )
  }

  render() {
    const { open, onClose, fullScreen, classes, isbn, bookName, mode } = this.props
    const {
      chapterStatuses,
      error,
      loading,
      reprocessing,
      selectedChapter,
      selectedChapterIndex,
      statusData,
      chapterDefaults,
    } = this.state

    const displayTitle = bookName || isbn
    const hasError = statusData && (statusData.erro || this.isErrorStatus(statusData.status || ''))
    const selectedIdVetor = this.getChapterIdVetor(selectedChapter)
    const selectedExistingContent = chapterStatuses[selectedIdVetor] || null
    const currentMode = mode || 'status'
    const modalTitle = currentMode === 'chapters'
      ? 'Vetorização de livros — Capítulos e cadastro CMS: '
      : 'Vetorização de livros — Status do processamento: '

    return (
      <React.Fragment>
        <Dialog
          modalId="vetorizacao-livros-processamento"
          modalParams={{ isbn }}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="md"
          open={open}
          onClose={onClose}
        >
          <DialogTitle id="vetorizacao-livros-processamento-title">
            {modalTitle}{displayTitle}
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            <div className={classes.headerInfo}>
              <Typography variant="caption" color="textSecondary">
                ISBN: {isbn}
              </Typography>
            </div>

            {currentMode === 'status' ? <BookVectorizationFlow compact /> : null}

            {loading && (
              <div className={classes.loadingOverlay}>
                <CircularProgress size={50} />
                <Typography variant="subtitle1" style={{ marginTop: 16 }}>
                  Carregando status...
                </Typography>
              </div>
            )}

            {!loading && error && (
              <div className={classes.errorBox}>
                <Typography variant="body1" color="error">
                  {error}
                </Typography>
                <Button color="primary" style={{ marginTop: 16 }} onClick={this.fetchProcessingData}>
                  Tentar novamente
                </Button>
              </div>
            )}

            {!loading && !error && currentMode === 'status' ? this.renderStatusSummary() : null}
            {!loading && !error && currentMode === 'chapters' ? this.renderCmsMetadataFields() : null}
            {!loading && !error && currentMode === 'chapters' ? this.renderChapterReview() : null}
          </DialogContent>

          <DialogActions>
            <Button onClick={this.fetchProcessingData} disabled={loading} style={{ marginRight: 'auto' }}>
              Atualizar
            </Button>
            <Button onClick={onClose}>Fechar</Button>
            <Button
              onClick={this.handleReprocess}
              color={hasError ? 'secondary' : 'primary'}
              variant="contained"
              disabled={loading || reprocessing}
            >
              {reprocessing ? 'Reprocessando...' : 'Reprocessar'}
            </Button>
          </DialogActions>
        </Dialog>

        {selectedChapter ? (
          <ChapterFormModal
            key={selectedIdVetor + '-' + selectedChapterIndex}
            open
            chapter={selectedChapter}
            chapterIndex={selectedChapterIndex}
            existingContent={selectedExistingContent}
            bookIsbn={this.state.cmsIsbnLivro || isbn}
            bookName={this.state.cmsTituloLivro || displayTitle}
            cms={this.getCmsBookData()}
            chapterDefaults={chapterDefaults}
            onConflict={this.handleChapterConflict}
            onClose={() =>
              this.setState({ selectedChapter: null, selectedChapterIndex: null })
            }
            onSaved={this.handleChapterSaved}
          />
        ) : null}
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeMessage: ({ message, type }) => {
    dispatch(messageActions.changeMessage({ message, type }))
  },
})

export default connect(
  null,
  mapDispatchToProps,
)(withMobileDialog()(withStyles(processingModalStyles)(ProcessingModal)))



// WEBPACK FOOTER //
// ./src/containers/BookVectorization/ProcessingModal/index.js